/* eslint-disable react-hooks/rules-of-hooks */
import Link from 'next/link'
import dynamic from 'next/dynamic'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Badge } from '@mui/material'
import styled from '@emotion/styled'
import { Close } from '@emotion-icons/material/Close'
import { Edit } from '@emotion-icons/material/Edit'
import { Shapes, Colors, useTypography, Typographies } from 'src/components/theme'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { InsightDownload } from 'src/views/insight-download'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'

import * as insightBuilderAtoms from 'src/atoms/insight-builder'

const InsightZipped = dynamic(() => import('src/components/insight-zipped/index'), {
  ssr: false,
})

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: ${Colors.bgWhite};
  border-bottom: 1px solid ${Colors.border};
  padding-inline: ${Shapes.spacing[6]}px;
  box-shadow: ${Colors.BOX_SHADOW};
  z-index: 2;
`

const Content = styled.div`
  max-width: 1130px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${Shapes.spacing[4]}px;
  padding: ${Shapes.spacing[4]}px ${Shapes.spacing[6]}px;
  margin-inline: auto;
`

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`

const CloseButton = styled(Close)`
  width: 20px;
  height: 20px;
  fill: ${Colors.textBlack};
  cursor: pointer;
  &:hover {
    fill: ${Colors.textDark};
  }
`
const Button = styled(ButtonWithIcon)`
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[3]}px;
`

const SelectedCountBadge = styled(Badge)`
  span.MuiBadge-badge {
    background-color: ${Colors.blueDark};
    color: ${Colors.bgWhite};
    ${useTypography(Typographies.text1)};
  }
`

export const InsightBuilderToolbar = () => {
  const [isConfiguring, setIsConfiguring] = useRecoilState(insightBuilderAtoms.isConfiguring)
  const insightTitle = useRecoilValue(insightBuilderAtoms.insightTitle)
  const selectedWidgets = useRecoilValue(insightBuilderAtoms.selectedWidgets)
  const { query } = useParsedRouter()

  const closeRedir = {
    pathname: '/',
    query: query,
  }

  const onEdit = () => setIsConfiguring(true)

  return (
    <Wrapper>
      <Content>
        <SelectedCountBadge badgeContent={selectedWidgets.length} color="primary">
          <Button onClick={onEdit}>
            <Edit color={Colors.blueDark} size={16} />
            Configure Widgets
          </Button>
        </SelectedCountBadge>
        <ButtonGroup>
          {!isConfiguring && (
            <>
              <InsightDownload
                style={{
                  padding: `${Shapes.spacing[2]}px ${Shapes.spacing[3]}px`,
                }}
                fileName={insightTitle}
              />
              <InsightZipped
                style={{
                  padding: `${Shapes.spacing[2]}px ${Shapes.spacing[3]}px`,
                }}
                filename={insightTitle}
              />
            </>
          )}
          <Link href={closeRedir}>
            <CloseButton />
          </Link>
        </ButtonGroup>
      </Content>
    </Wrapper>
  )
}
